import React from 'react';
import { BarChart3, PieChart } from 'lucide-react';

const CategorySummary = ({ summary, totalSpending, categories, getCategoryGradient }) => {
  return (
    <div className="bg-white/90 backdrop-blur-xl rounded-3xl p-8 border border-pink-200 shadow-xl">
      <div className="flex items-center mb-5">
        <div className="p-2 bg-gradient-to-br from-purple-500 to-pink-600 rounded-xl mr-3 shadow-lg">
          <BarChart3 className="w-5 h-5 text-white" />
        </div>
        <h2 className="text-xl font-bold text-gray-900">Category Breakdown</h2>
      </div>

      {Object.keys(summary).length === 0 ? (
        <div className="text-center py-16">
          <div className="inline-block p-5 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-2xl mb-4">
            <PieChart className="w-14 h-14 text-blue-600" />
          </div>
          <p className="text-gray-600 font-medium text-base">No expenses yet. Start tracking to see insights!</p>
        </div>
      ) : (
        <div className="space-y-4">
          {Object.entries(summary).map(([cat, total]) => {
            const percentage = (total / totalSpending) * 100;
            const gradient = getCategoryGradient(cat);
            return (
              <div key={cat} className="group p-3 -mx-3 rounded-lg hover:bg-gray-50 transition-all duration-200">
                <div className="flex items-center justify-between mb-1.5">
                  <span className="text-gray-800 font-semibold text-sm">{categories.find(c => c.value === cat)?.label || cat}</span>
                  <span className="text-gray-900 font-bold text-md">₹{total.toFixed(2)}</span>
                </div>
                <div className="relative h-3 bg-gray-100 rounded-full overflow-hidden shadow-inner">
                  <div
                    className={`absolute h-full bg-gradient-to-r ${gradient} rounded-full transition-all duration-700 shadow-lg`}
                    style={{ width: `${percentage}%` }}
                  ></div>
                </div>
                <div className="text-right text-xs text-gray-500 font-medium mt-0.5">{percentage.toFixed(1)}%</div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CategorySummary;
